<template>
  <div class="app-layout">
    <!-- 导航栏 -->
<!--    <nav class="navbar" v-if="showNavbar">-->
<!--      <div class="nav-container">-->
<!--        <div class="nav-brand">-->
<!--          <router-link to="/" class="brand-link">BioRender管理系统</router-link>-->
<!--        </div>-->
<!--        <div class="nav-menu">-->
<!--          <router-link to="/" class="nav-link">激活账户</router-link>-->
<!--          <router-link-->
<!--            v-if="isAdmin"-->
<!--            to="/admin"-->
<!--            class="nav-link"-->
<!--          >-->
<!--            管理控制台-->
<!--          </router-link>-->
<!--          <div class="nav-user" v-if="currentUser">-->
<!--            <span class="user-info">{{ currentUser.email }}</span>-->
<!--            <button @click="logout" class="logout-btn">退出</button>-->
<!--          </div>-->
<!--          <router-link v-else to="/login" class="nav-link login-link">登录</router-link>-->
<!--        </div>-->
<!--      </div>-->
<!--    </nav>-->

    <!-- 主内容区域 -->
    <main class="main-content" :class="{ 'with-navbar': showNavbar }">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'App',
  data() {
    return {
      currentUser: null
    }
  },
  computed: {
    showNavbar() {
      // 只在管理员页面显示导航栏
      return this.$route.path.startsWith('/admin')
    },
    isAdmin() {
      return this.currentUser && this.currentUser.role === 'admin'
    }
  },
  mounted() {
    this.loadCurrentUser()
    this.setupMessageSystem()
  },
  watch: {
    '$route'() {
      this.loadCurrentUser()
    }
  },
  methods: {
    loadCurrentUser() {
      const token = localStorage.getItem('token')
      const userInfo = localStorage.getItem('userInfo')
      
      if (token && userInfo) {
        try {
          this.currentUser = JSON.parse(userInfo)
        } catch (error) {
          console.error('解析用户信息失败:', error)
          this.currentUser = null
        }
      } else {
        this.currentUser = null
      }
    },
    logout() {
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('userRole')
      this.currentUser = null
      this.$router.push('/login')
    },
    setupMessageSystem() {
      // 全局消息提示系统
      this.$message = {
        success: (msg) => this.showMessage(msg, 'success'),
        error: (msg) => this.showMessage(msg, 'error'),
        warning: (msg) => this.showMessage(msg, 'warning'),
        info: (msg) => this.showMessage(msg, 'info')
      }
      
      // 将消息系统挂载到Vue原型上
      Vue.prototype.$message = this.$message
    },
    showMessage(text, type = 'info') {
      const messageEl = document.createElement('div')
      messageEl.className = `message ${type}`
      messageEl.textContent = text
      document.body.appendChild(messageEl)
      
      setTimeout(() => {
        if (messageEl.parentNode) {
          messageEl.parentNode.removeChild(messageEl)
        }
      }, 3000)
    }
  }
}
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
</style>
